import React, { useContext } from 'react';
import { GlobalContext } from './contexts/GlobalContext';
import MenuBar from './MenuBar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import DialogActions from '@material-ui/core/DialogActions';
import SettingsIcon from '@material-ui/icons/Settings';
import './Header.css';
import SettingsMain from './Settings/SettingsMain';

function Header() {
	const [open, setOpen] = React.useState(false);
	// const [working, setWorking] = React.useState(false);

	const globals = useContext(GlobalContext)


	const handleClickOpen = async () => {
		setOpen(true);
		globals.initAnalytics();
		globals.logEventAnalytics(
			"Header",
			"Settings - Display Modal",
			"Settings");
	};

	const handleClose = () => {
		setOpen(false);
	};


	return (
		<React.Fragment>
			<div className="header">
				<div className="header__logo">
					<div className="header__left">
						<img className="header_image" src={globals.iconurl} alt="" />
					</div>
					<div className="header__middle">{globals.config.name}</div>
					<div className="header__right">
						<SettingsIcon className="header__settings" onClick={() => { handleClickOpen(); }} />
					</div>
				</div>
				<MenuBar />
			</div>
			<Dialog fullWidth={true} maxWidth="sm" open={open}>
				<div className="header__dialogTitleContainer">
					<div className="header__dialogTitleParts">
						Settings
						</div>
				</div>
				<SettingsMain />
				<DialogActions>
					<Button
						onClick={handleClose}
						variant="contained"
						color="primary"
					>Close</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);

}

export default Header;
